import { createContext } from "react";

export const rateFeeData = [
  {
    uniqueWithoutProduct: "50 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 50,
    lvrRange: "≤ 50%",
    borrowerRate: 5.89,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 5.99,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "60 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 60,
    lvrRange: "≤ 60%",
    borrowerRate: 5.99,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 6.09,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "65 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 65,
    lvrRange: "≤ 65%",
    borrowerRate: 5.99,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 6.09,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "70 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 70,
    lvrRange: "≤ 70%",
    borrowerRate: 5.99,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 6.09,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "75 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 75,
    lvrRange: "≤ 75%",
    borrowerRate: 6.02,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 6.12,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "80 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 80,
    lvrRange: "≤ 80%",
    borrowerRate: 6.04,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 6.14,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "85 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 85,
    lvrRange: "≤ 85%",
    borrowerRate: 6.17,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 6.27,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "90 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 90,
    lvrRange: "≤ 90%",
    borrowerRate: 6.24,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 6.34,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "95 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 95,
    lvrRange: "≤ 95%",
    borrowerRate: 7.04,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 7.14,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "100 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 100,
    lvrRange: "≤ 100%",
    borrowerRate: 9.09,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 9.19,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "105 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 105,
    lvrRange: "≤ 105%",
    borrowerRate: 10.09,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 10.19,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
  {
    uniqueWithoutProduct: "110 Owner occupied P&I Variable",
    propertyUsage: "Owner occupied",
    repaymentType: "P&I",
    interestType: "Variable",
    product: "Ultra Prime I",
    docType: "Full Doc",
    lvr: 110,
    lvrRange: "≤ 110%",
    borrowerRate: 11.09,
    // comparisonRate: 6.59,
    // offsetBorrowerRate: 6.19,
    // offsetComparisonRate: 6.59,
    baseRate: 11.19,
    discount: 0.00,
    // dataEntryAdditionalMargin: 0.00,
    // residencyLoading: 100,
    // politicallyExposed: 100,
    // highRiskCountries: 100,
    // facilityTypeLoading: 100,
    // managerDiscretion: 0.30,
    // monthlyFee: 32.92
  },
]

export const RateFeeDispatchContext = createContext<any>(null)

export const RateFeeContext = createContext<any[]>(rateFeeData)